import React, { useCallback } from 'react';
import { Row } from 'react-bootstrap';
import { Field } from 'formik';
import { FormCol, FormFilterCard, FieldDateRanger, CustomSelectComponent } from 'motion-components';

export type UsersStatsGroupBy = 'day' | 'hour';

export interface UsersStatsFilterValues {
  fromDate: Date;
  tillDate: Date;
  groupBy: UsersStatsGroupBy;
}

const groupByOptions = [
  { value: 'day', label: 'Ανά Ημέρα' },
  { value: 'hour', label: 'Ανά Ώρα' },
];

interface FiltersProps {
  onChange: (values: UsersStatsFilterValues) => void;
  initialValues: UsersStatsFilterValues;
}

/** Φίλτρα αναζήτησης: εύρος ημερομηνιών και τρόπος ομαδοποίησης */
export const Filters = ({ onChange, initialValues }: FiltersProps) => {
  const handleFiltersSubmit = useCallback(
    (values: UsersStatsFilterValues, { setSubmitting }) => {
      setTimeout(() => {
        setSubmitting(false);
        onChange(values);
      }, 200);
    },
    [onChange],
  );

  return (
    <FormFilterCard title="Κριτήρια Αναζήτησης" onSubmit={handleFiltersSubmit} initialValues={initialValues}>
      <Row className="mb-4">
        <FieldDateRanger as={FormCol} label="Ημ/νία Από" name="fromDate" name2="tillDate" />
        <Field
          as={FormCol}
          name="groupBy"
          title="Ομαδοποίηση"
          component={CustomSelectComponent}
          options={groupByOptions}
          isClearable={false}
        />
      </Row>
    </FormFilterCard>
  );
};
